import React from 'react';
import { Card, Spin, Row, Col } from 'antd';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'dva';
import moment from 'moment-timezone';
import helpers from '../../../utils/helpers';
import { PageHeader, VisitsTable } from '../../../components';
import styles from '../styles.less';


class LeadVisitDetails extends React.Component {
  constructor(props) {
    super(props);

    const urlParams = this.props.match.params;
    this.projectId = urlParams.projectId;
    this.leadId = urlParams.companyId;
    this.visitId = urlParams.visitId;

    this.state = {
      company: {
        company_name: '',
      },
    };
  }

  componentDidMount() {
    if (!this.props.matomo.leadDetails) {
      this.props.dispatch({
        type: 'leads/getDetails',
        payload: {
          projectId: this.projectId,
          leadId: this.leadId,
          simpleRequest: true,
        },
      }).then((leadDetails) => {
        this.props.dispatch({
          type: 'matomo/updateStore',
          payload: { leadDetails },
        });
      });
    }

    this.props.dispatch({
      type: 'matomo/getCompanyVisitDetails',
      payload: {
        projectId: this.projectId,
        companyId: this.leadId,
        visitId: this.visitId,
      },
    }).then((resp) => {
      if (!resp) {
        // eslint-disable-next-line no-console
        console.error('No visit details', resp);
        return;
      }
      this.props.dispatch({
        type: 'matomo/updateStore',
        payload: {
          visitDetails: {
            ...resp,
            campaignName: resp.campaign_name,
            adCampaign: resp.ad_campaign,
          },
        },
      });
    });
  }

  componentDidUpdate(prevProps) {
    if ((this.props.matomo.leadDetails && !prevProps.matomo.leadDetails)
      || ((prevProps.matomo.leadDetails && this.props.matomo.leadDetails)
        && (prevProps.matomo.leadDetails.id !== this.props.matomo.leadDetails.id))) {
      this.props.dispatch({
        type: 'header/update',
        payload: {
          variable: this.props.matomo.leadDetails.company_name,
        },
      });
    }
  }

  getTime(time) {
    const tz = moment.tz(time, this.props.app.user.display_timezone);
    return moment(tz).format(this.props.app.user.display_datetime_format);
  }

  getModifiedVisitDetails() {
    const { visitDetails } = this.props.matomo;
    return visitDetails.page_views_details.map((view) => {
      const dynamicContent = view.dynamic_content.length ? 'Yes' : 'No';
      return {
        position: view.interaction_position,
        number: view.interaction_position,
        pageTitle: view.page.url ? <a href={view.page.url} target="_blank" rel="noopener noreferrer">
          {view.page.title || view.page.url}</a> : <div>{view.search.keyword}</div>,
        duration: helpers.getTimeFromDuration(view.duration, 'seconds'),
        dynamicContent: <FormattedMessage id={`Common.${dynamicContent}`} />,
      };
    });
  }

  cancelAction() {
    this.props.dispatch({
      type: 'app/goToRoute',
      payload: {
        routeName: 'LEAD_VISIT_DETAILS',
        projectId: this.projectId,
        leadId: this.leadId,
      },
    });
  }

  render() {
    const { loading, matomo } = this.props;
    const {
      adCampaign,
      first_action_timestamp,
      last_action_timestamp,
      visit_duration,
      entry_page,
      exit_page,
    } = matomo.visitDetails;

    return (
      <div>
        <Spin
          spinning={!!loading.effects['matomo/getCompanyVisitDetails'] || loading.effects['leads/getDetails']}
          className={styles.companySpinContainer}
        >
          <Card className="card-single card-multiple">
            <Row type="flex" gutter={{ xs: 8, sm: 16, md: 24 }}>
              <Col xxl={6} xl={8} lg={10} md={24} sm={24} xs={24}>
                <h4><FormattedMessage id="Common.StartDate" /></h4>
                <div className="text">{this.getTime(first_action_timestamp)}</div>
                <h4><FormattedMessage id="Common.EndDate" /></h4>
                <div className="text">{this.getTime(last_action_timestamp)}</div>
              </Col>
              <Col xxl={4} xl={6} lg={10} md={24} sm={24} xs={24}>
                <h4><FormattedMessage id="Common.TotalTimeOnVisit" /></h4>
                <div className="text">{helpers.getTimeFromDuration(visit_duration, 'seconds')}</div>
                <h4><FormattedMessage id="Grid.Column.Campaign" /></h4>
                <div className="text">
                  {adCampaign ?
                    <span>{matomo.visitDetails.campaign_keyword}</span> :
                    <FormattedMessage id={'Common.No'} />
                  }
                </div>
              </Col>
              <Col xxl={8} xl={8} lg={12} md={24} sm={24} xs={24}>
                <h4><FormattedMessage id="Common.EntryPage" /></h4>
                <div className="text">
                  {entry_page ? (
                    <a className="link" href={entry_page.url} target="_blank" rel="noopener noreferrer">
                      {entry_page.title || entry_page.url}
                    </a>
                  ) : (
                    <FormattedMessage id="Common.NoData" />
                  )}
                </div>
                <h4><FormattedMessage id="Common.ExitPage" /></h4>
                <div className="text">
                  {exit_page ? (
                    <a className="link" href={exit_page.url} target="_blank" rel="noopener noreferrer">
                      {exit_page.title || exit_page.url}
                    </a>
                  ) : (
                    <FormattedMessage id="Common.NoData" />
                  )}
                </div>
              </Col>
            </Row>
          </Card>
          <hr />
          <PageHeader
            onBackToOverview={this.cancelAction.bind(this)}
            backText={'Common.BackToAllVisits'}
          >
            <FormattedMessage id="Component.NavMenu.LeadManagement.AllVisitDetailsTitle" />
          </PageHeader>
          <hr />
          <VisitsTable
            dataSource={this.getModifiedVisitDetails()}
            rowKey="position"
            columnBtn={<FormattedMessage id="Common.More" />}
            includeParam="page"
            columnBtnAction={{
              routeName: 'LEAD_VISIT_PAGE_DETAILS',
              params: {
                projectId: this.projectId,
                companyId: this.leadId,
                visitId: this.visitId,
              },
            }}
          />
        </Spin>
      </div>
    );
  }
}

export default connect(({ loading, app, matomo }) =>
  ({ loading, app, matomo }))(injectIntl(LeadVisitDetails));



// WEBPACK FOOTER //
// ./src/components/Leads/LeadVisitDetails/LeadVisitDetails.js